const steps = [
  {
    number: '01',
    title: 'Entendimento do problema',
    description:
      'Ouvimos, perguntamos e mapeamos o cenário atual do seu negócio para entender de verdade o que precisa ser resolvido.',
  },
  {
    number: '02',
    title: 'Análise técnica e estratégia',
    description:
      'Definimos a melhor abordagem, arquitetura e tecnologias com base nos seus objetivos e restrições.',
  },
  {
    number: '03',
    title: 'Desenvolvimento da solução',
    description:
      'Construímos com agilidade, qualidade e entregas incrementais para que você acompanhe cada evolução.',
  },
  {
    number: '04',
    title: 'Entrega, suporte e evolução',
    description:
      'Após a entrega, seguimos juntos. Oferecemos suporte contínuo e evoluímos a solução conforme seu negócio cresce.',
  },
];

export function Process() {
  return (
    <section id="processo" className="bg-primary py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-accent">
            Como trabalhamos
          </p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl text-balance">
            Do problema à solução, passo a passo
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-primary-foreground/70">
            Um processo claro e colaborativo que garante resultados consistentes.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div key={step.number} className="relative">
              <div className="h-full rounded-xl border border-primary-foreground/10 bg-primary-foreground/5 p-6 backdrop-blur-sm">
                <span className="font-heading text-3xl font-bold text-accent">
                  {step.number}
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-primary-foreground">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-primary-foreground/60">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
